import React from 'react'
import { useTranslation } from '@/shared/hooks/useIntractionTranslate'
import type { DraftJsContent } from 'pure-js/libs/Common'
import { GlintFeedbackTextSection } from './GlintFeedbackTextSection'

export interface WatchOutSectionProps {
  content: string | DraftJsContent
  showGlowExperience?: boolean
  onGlowExperienceComplete?: () => void
  onGlintStateChange?: (state: 'idle' | 'running') => void
}

export const WatchOutSection: React.FC<WatchOutSectionProps> = (props) => {
  const { t } = useTranslation()
  return (
    <GlintFeedbackTextSection
      {...props}
      title={t('gamer.feedback.sections.watchOut.title', 'Watch out')}
      variant="warning"
    />
  )
}

export default WatchOutSection
